import React from 'react'
import SbEditable from 'storyblok-react'

import Carousel from './../Carousel'
import Components from './../Components'

import styles from './styles.module.scss'

const Testimonials = (props) => {
    
    const params = {
        slidesPerView: 1,
        loop: true,
        centeredSlides: true,
        speed: 750,
        preloadImages: false,
        autoplay: {
            delay: 7500,
            disableOnInteraction: false
        }   
    }

	return (
		<SbEditable content={props.blok}>
			<section className={styles['testimonials']}>
                {props.blok.vertical_title && <span className={'section-title'}>{props.blok.title}</span>}
                {props.blok.testimonial_items.length > 1 ? (
                    <Carousel params={params}>
                        {props.blok.testimonial_items && props.blok.testimonial_items.map((blok) => 
                            React.createElement(Components(blok.component), {
                                key: blok._uid, 
                                blok: blok
                            })
                        )}
                    </Carousel>
                ) : (
                    <>
                        {props.blok.testimonial_items && props.blok.testimonial_items.map((blok) => 
                            React.createElement(Components(blok.component), {
                                key: blok._uid, 
                                blok: blok
                            })
                        )}
                    </>
                )}
            </section>
		</SbEditable>
	)
}

export default Testimonials
